import { reactive } from 'vue';
export const globals = reactive({
    now_showing: 'panel',
    notify: () => {},
})